export default __webpack_public_path__ + "static/media/deephouse.89539d7c.png";